import { useExperienceWizard } from 'core/contexts/experienceWizard';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-final-form';
import { Box, Grid2 } from '@mui/material';
import ActionButtons from 'modules/Pricing/PriceGroupWizard/components/ActionButtons';
import Title from 'modules/Pricing/components/Title';
import LocationFormFields from 'modules/Experience/components/LocationFormFields';
import { validateLocationData } from '@utriper/core';

const LocationForm = () => {
    const { t } = useTranslation();
    const translate = (key) => t(`experience_form.location_data.${key}`);
    const { stepData, handleBack, handleNext, updateStepData, STEP_KEYS } = useExperienceWizard();

    const handleSubmit = (values) => {
        updateStepData(STEP_KEYS.STEP_2, values);
        handleNext();
    };

    const validateForm = (values) => {
        const errors = {};

        if (!values?.locationData || !validateLocationData(values?.locationData)) {
            errors.locationData = t('common_form.required');
        }

        return errors;
    };

    return (
        <Form
            onSubmit={handleSubmit}
            validate={validateForm}
            initialValues={stepData[STEP_KEYS.STEP_2]}
            render={({ handleSubmit, values }) => (
                <form onSubmit={handleSubmit} noValidate style={{ width: '100%', maxWidth: '480px' }}>
                    <Box component="section">
                        <Title title={translate('title')} description={translate('description')} />

                        {/* Form */}
                        <Grid2 container width="100%" direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px" mt="24px">
                            <LocationFormFields />
                        </Grid2>

                        <ActionButtons
                            handleSubmit={(e) => {
                                return handleSubmit(e);
                            }}
                            handleBack={handleBack}
                        />
                    </Box>
                </form>
            )}
        />
    );
};

export default LocationForm;
